import React from "react";

const Markup = ({ renderField, renderSelect, Button, ...props }) => {
    const { name } = props;
    return (
        <div>
            {renderField(name)}
            {!!Button && <Button />}
        </div>
    );
};

export default Markup;
